export const environment = {
    production: true,
    baseHref: '/',
    myPatUrl: 'http://fb1.mypat.in',
    myPatUrlv4: 'http://fb1-v4.mypat.in',
    fiitjeeUrlv3: 'https://fb1-fiitjee-v3.mypat.in',
    fiitjeeUrlv4: 'https://fb1-fiitjee.mypat.in',
    serverURLv4: 'https://fb1-api-v4.mypat.in/',
    serverURLv3: 'https://fb1-api.mypat.in/',
    edforaURL: 'https://backend.edfora.com/',
    serverURLv3_prod: 'https://v2api2-prod.mypat.in/',
    mockServerURL: 'http://fb1-api-mock.mypat.in/',
    fbAppId: '716515672297201',
    google_clientId: '626029703118-cgvg899p8o9mbktbsl3g0244eh8ufe0d.apps.googleusercontent.com',
    partnerDomain: 'http://fb1-fiitjee.mypat.in/auth/admin-access/',
    razorPayKey: 'rzp_test_qMb3Ka63Y6heW9',
    clevertapId: 'TEST-798-8W8-545Z',
    GCM_Sender_key : '189667902791',
    GCM_server_API_key : 'AIzaSyAbXH2Ah7tkUZC9VfjtRfDVFJHQsH9poSE',
    kaptureCrmKey : 'Basic aDM3b2FtcmtjYzY1dHhzbzl6bDFmM2hoNnNodWF2cnNsenM5bGJuaGN1M3NqYnowdGg=',
    name: 'feature',
    captchaKey : '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    zestMoneyMerchantId: '89cad954-b7ea-47a9-af2d-8c9a0027357f',
    zestMoneyPaymentGatewayId: '31a2b66b-f364-48f9-a7fd-6870a5a224b4',
    teacherSiteURL: 'https://fb1-teachers.mypat.in/public/login',
    schoolPartnerDomain: 'http://fb1-schools.mypat.in/',
    teacherServerURL: 'http://fb1schoolpat.mypat.in/',
    s3BucketBaseUrl: 'https://s3.us-west-2.amazonaws.com/mypat-v2-staging/',
    glorifireCommunity: 'https://community.glorifire.com',
    glorifireliveClasses: 'https://liveclasses.glorifire.com',
    gtmId: 'GTM-KDN5S4Q',
    androidURL:'https://play.google.com/store/apps/details?id=com.mypat',
    iosURL:'',
    youTube:'https://youtube.com/@myPATlearning?si=X90qIGlwgEDOG0jps',
    instagram:'https://www.instagram.com/mypat_india/',
    linkedIn:'https://www.linkedin.com/company/mypat---my-performance-analysis-test?report%2Esuccess=KJ_KkFGTDCfMt-A7wV3Fn9Yvgwr02Kd6AZHGx4bQCDiP6-2rfP2oxyVoEQiPrcAQ7Bf',
    twitter:'https://twitter.com/myPAT_india',
    facebook:'https://www.facebook.com/pages/MyPatin/249818108402322',
    glorifireLite: 'https://fb1-v4-lite.mypat.in/',
    blog:'https://blog.mypat.in/',
  };
